import React from 'react';

import component, {classnames} from './component';
import {HBox, VBox} from './Box';
import {Clock} from './icons';
import HtmlContent from './HtmlContent';
import Share from './Share';
import emptyPic from './emptyPic';

const Image = component('Image', {

  getInitialState() {
    return {
      height: 0
    }
  },

  componentDidMount() {
    const self = this;
    const img = document.createElement('img');

    img.src = this.props.image || emptyPic;

    img.onload = function() {
      self.setState({
        height: this.height
      })
    }
  },

  render() {
   return (
     <div className="TypicalContent-Image" style={{
       height: this.state.height,
       backgroundImage: this.props.image ? `url(${this.props.image})` : 'none'
     }}></div>
   )
  }

});

export default component('TypicalContent', function({data, created, title, image, text, advert, type}) {

  const pageCls = {"TypicalContent": true};

  pageCls["TypicalContent--" + (type ? 'News' : 'Simple')] = true;

  return (
    <div className={classnames(pageCls)}>
      <div className="TypicalContent-Head">
        {
          type && <div className="TypicalContent-Type">{type}</div>
        }
        {
          created
          &&
          <div className="TypicalContent-Date">
            <Clock className="TypicalContent-Clock" />
            {created}
          </div>
        }
      </div>
      <div className="TypicalContent-Title">
        {title}
      </div>
      {image && <Image image={image} />}
      <div className="TypicalContent--ContentWrap">
        <div className="TypicalContent-Content">
          <HtmlContent className="TypicalContent-Text" html={text} />
        </div>
        { advert &&
          <div className="TypicalContent-Advert">
            {advert}
          </div>
        }
      </div>
      {
        type
        &&
        <div className="TypicalContent-Share--Wrap">
          <div className="TypicalContent-Share">
            Поделиться
            <Share />
          </div>
        </div>
      }
    </div>
  )
});



// WEBPACK FOOTER //
// ./src/components/TypicalContent.js